// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMaterial from 'vue-material'
import App from './App'
import router from './router'

import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'

import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default-dark.css' // This line here

Vue.use(VueMaterial)
Vue.use(VueFire)

Vue.config.productionTip = false

// Initialize Firebase
let app
let config = {
  apiKey: 'AIzaSyCwl7syKL40b8X7Jh2qOEx6f765IDP7fxU',
  authDomain: 'commitmentcoach-40a6c.firebaseapp.com',
  databaseURL: 'https://commitmentcoach-40a6c.firebaseio.com',
  projectId: 'commitmentcoach-40a6c',
  storageBucket: 'commitmentcoach-40a6c.appspot.com',
  messagingSenderId: '810679794118'
}

firebase.initializeApp(config)

export const db = firebase.firestore()
const settings = {timestampsInSnapshots: true}
db.settings(settings)

firebase.auth().onAuthStateChanged(function (user) {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js